import { Button, Card, Typography } from 'antd';

import BrazilFlag from '../icons/BrazilFlag';
import EuroFlag from '../icons/EuroFlag';
import UsaFlag from '../icons/UsaFlag';
import { Modrawer } from '../Modrawer';

const InternationalFee = ({
  openInternationalTaxes,
  setOpenInternationalTaxes
}: {
  openInternationalTaxes: boolean;
  setOpenInternationalTaxes: (open: boolean) => void;
}) => {
  return (
    <Modrawer
      open={openInternationalTaxes}
      title={<div className='text-center'>Vendas internacionais</div>}
      onCancel={() => setOpenInternationalTaxes(false)}
      width={420}
      footer={[
        <Button
          className='w-full md:w-auto'
          id='btn-ok-taxes'
          type='primary'
          key='ok'
          onClick={() => setOpenInternationalTaxes(false)}
        >
          Entendi
        </Button>
      ]}
    >
      <div className='flex flex-col gap-4 px-2 py-4'>
        <div className='flex flex-col gap-1'>
          <Typography.Title level={5} className='mb-0'>
            Entenda o preço para vendas internacionais
          </Typography.Title>
          <div className='text-content-subtitle text-sm'>
            Os valores serão convertidos automaticamente. Com o valor que você escolheu, os preços ficam assim:
          </div>
        </div>

        <Card
          size='small'
          className='bg-surface-subtle border-outline-disabled border'
          classNames={{ body: 'divide-outline-disabled divide-y p-0 text-sm' }}
        >
          <div className='flex w-full justify-between p-2'>
            <div className='flex w-full items-center gap-1'>
              <BrazilFlag />
              <div>Real (BRL)</div>
            </div>
            <span className='flex w-full justify-end font-semibold'>R$ 29,90</span>
          </div>

          <div className='flex w-full justify-between p-2'>
            <div className='flex w-full items-center gap-1'>
              <UsaFlag />
              <div>Dólar</div>
            </div>
            <span className='flex w-full justify-end font-semibold'>$ 6,00</span>
          </div>

          <div className='flex w-full justify-between p-2'>
            <div className='flex w-full items-center gap-1'>
              <EuroFlag />
              <div>Euro</div>
            </div>
            <span className='flex w-full justify-end font-semibold'>€ 4,98</span>
          </div>
        </Card>

        <div className='text-content-title text-xs font-semibold'>
          Mesmo com a conversão automática, você sempre receberá o valor final em reais (BRL).
        </div>

        <div className='text-content-subtitle text-xs'>
          Se preferir, você pode criar outras ofertas para este mesmo produto depois, definindo o valor que deseja
          cobrar em cada moeda.
        </div>
      </div>
    </Modrawer>
  );
};

export default InternationalFee;
